module.exports = __webpack_public_path__ + "img/time.7119b9b9.svg";